import { createSlice } from '@reduxjs/toolkit';

export const loadingSlice = createSlice({
  name: "loading",
  initialState: {
    activeCalls: 0,
    isLoading: false
  },
  reducers: {
    incrementActiveCalls: (state) => {
      state.activeCalls++;
      state.isLoading = state.activeCalls > 0;
    },
    decrementActiveCalls: (state) => {
      state.activeCalls = Math.max(0, state.activeCalls - 1);
      state.isLoading = state.activeCalls > 0;
    },
  },
});

export const { incrementActiveCalls, decrementActiveCalls } = loadingSlice.actions;
export default loadingSlice.reducer;